import styled from "styled-components";

export const BaseSelectWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.8;
  }

  .select-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .MuiInputBase-root {
    width: 100%;
    font-size: 13px;
    box-sizing: border-box;
    min-width: 0;
  }

  .MuiOutlinedInput-root {
    border-radius: 8px;
    background: #f9fbff;
    transition: all 0.2s ease;
    min-width: 0;
    width: 100%;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid #d5dbe7;
  }

  .MuiOutlinedInput-root:hover {
    background: #f4f8ff;
  }

  .MuiOutlinedInput-root.Mui-focused {
    box-shadow: 0 0 0 2px rgba(76, 139, 245, 0.15);
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.blue700};
  }

  .MuiSelect-select {
    padding: 8px 32px 8px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    max-width: 100%;
  }

  .MuiOutlinedInput-notchedOutline legend {
    display: none;
  }

  .MuiOutlinedInput-notchedOutline {
    top: 0;
  }
    
  .info-icon {
   margin-top: 7px
  }
  
`